import { render, staticRenderFns } from "./MandatoryTwoFAModal.vue?vue&type=template&id=d55d6de2"
import script from "./MandatoryTwoFAModal.vue?vue&type=script&lang=js"
export * from "./MandatoryTwoFAModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports